import { sectionRenderer } from '@theme/section-renderer';
import { StandardEvents } from '@shopify/events';

const drawer = document.getElementById('cart-drawer');
if (drawer) {
 const panel = drawer.querySelector('dialog');
 let loading = false, scrollState = null;
 const opener = document.querySelector('.ldh-icon[href="/cart"]');
 opener?.setAttribute('aria-haspopup', 'dialog');
 opener?.setAttribute('aria-controls', 'cart-drawer');
 opener?.setAttribute('aria-expanded', 'false');
 async function openCart(trigger) {
  if (loading) return;
  loading = true;
  trigger?.setAttribute('aria-busy', 'true');
  try {
   await customElements.whenDefined('theme-drawer');
   await sectionRenderer.renderSection('cart-drawer-section', {cache: false, mode: 'hydration'});
   trigger?.focus({preventScroll:true});
   drawer.open();
  } catch (error) {
   // A real cart page remains available if section rendering is unavailable.
   window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
  } finally {
   loading = false;
   trigger?.removeAttribute('aria-busy');
  }
 }
 document.addEventListener('click', event => {
  const link = event.target.closest('.ldh-icon[href="/cart"], [data-feedback-cart-link]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  const quick = document.querySelector('#lf-purchase');
  if (quick?.open) {
   quick.addEventListener('close', () => openCart(opener), {once:true});
   quick.close();
  } else openCart(link);
 });
 document.addEventListener('loom:cart-added', event => openCart(event.detail?.opener || opener));
 drawer.addEventListener('theme-drawer:open', () => {
  const scroller=document.querySelector('.page-wrapper');
  if (!scrollState && scroller) {scrollState={scroller, overflow:scroller.style.overflow};scroller.style.overflow='hidden';}
  opener?.setAttribute('aria-expanded','true');
 });
 drawer.addEventListener('theme-drawer:close', () => {
  if(scrollState){scrollState.scroller.style.overflow=scrollState.overflow;scrollState=null;}
  opener?.setAttribute('aria-expanded','false');
 });
 panel.addEventListener('keydown', event => {
  if(event.key!=='Tab')return;
  const items=[...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex="0"]')].filter(e=>e.getClientRects().length);
  const first=items[0],last=items.at(-1);
  if(event.shiftKey && document.activeElement===first){event.preventDefault();last?.focus();}
  else if(!event.shiftKey && document.activeElement===last){event.preventDefault();first?.focus();}
 });
 document.addEventListener(StandardEvents.cartError, async () => {
  drawer.querySelectorAll('input[name="updates[]"]').forEach(input => { input.value=input.defaultValue; });
  try {
   // Reconcile optimistic removals and quantity changes against Shopify, without retrying the mutation.
   await sectionRenderer.renderSection('cart-drawer-section', {cache:false, mode:'hydration'});
  } catch (_) { /* Keep the last known cart and a visible error when the network remains unavailable. */ }
  const status=drawer.querySelector('[data-loom-cart-error]');
  if(status) status.textContent='Bijwerken is niet gelukt. Controleer je winkelwagen en probeer opnieuw.';
 });
 document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  event.promise?.then(()=>{
   const status=drawer.querySelector('[data-loom-cart-error]');if(status)status.textContent='';
   if(event.action==='add') openCart(opener);
  }).catch(()=>{});
 });
}
